package kz.dentalcrm.app.theme.shimmer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.toSize

@Composable
internal actual fun rememberWindowBounds(): Rect {
    val windowInfo = LocalWindowInfo.current.containerSize

    return remember(windowInfo) {
        Rect(Offset.Zero, windowInfo.toSize())
    }
}
